// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NxHA1","col":"styles_col__JBl_c"};